import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode est volontairement DÉSACTIVÉ ici car il double-monte
// les composants en mode dev, ce qui pose problème avec la scène Three.js du
// module Anatomie 3D (init effet créant scène + renderer + animation loop).
// Cf. https://github.com/mrdoob/three.js/issues/22833
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);

// Enregistrement du Service Worker pour PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker enregistré avec succès:', registration.scope);
      })
      .catch((error) => {
        console.log('Erreur lors de l\'enregistrement du Service Worker:', error);
      });
  });
}
